import React from 'react';
import { useTranslations } from '@lang';

import Alert from '@common/components/Alert/Alert';

export const NoRatesAvailable = () => {
  const { t } = useTranslations();

  return <Alert title={t('room.noRatesHeader')} content={t('room.noRatesInfo')} />;
};
